// extracted by mini-css-extract-plugin
export var voiceConversionContent = "_n4-0";